import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
    strict: false,
    plugins: [vuexLocal.plugin],
    state: {
      userInfo: null,
      token:null,
    },
    getters: {
      getUserInfo(state){
        return state.userInfo
      },
      getToken(state){
        return state.token
      },
    },
    mutations: {
      setUserInfo(state,userInfo){
        state.userInfo = userInfo
      },
      clearUserInfo(state){
        state.userInfo = null
      },
      setToken(state,token){
        state.token = token
      },
      clearToken(state){
        state.token = null
      },
    },
    actions:{
      login({commit},user){
        commit('setUserInfo',user)
      },
      logout({ commit }) {
        commit('clearUserInfo');
      },
      logintoken({commit},token){
        commit('setToken',token)
      },
      outtoken({commit}){
        commit('clearToken')
      }
    }
})

export default store